module.exports = __webpack_public_path__ + "static/media/q-fever-news.69a448cb.jpg";